import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'customDecimal',
    standalone: false
})
export class CustomDecimalPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    const numberCheck = parseFloat(value)
    return numberCheck.toFixed(2)
  }
}
